
export class EavPatternModel {
    attributeId: string;
    attributeName: string;
    attributeValueId: string;
    attributeValue: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/eav-pattern-model.ts